import request from '@/modules/base/util/request'

import accountConfig from '../config'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const { endpoints } = accountConfig

export const UserService = {
  email: {
    /**
             * get confirmation state of user
        */
    getConfirmationState: () => {
      return new Promise((resolve, reject) => {
        request(endpoints.getRegistrationConfirmation, {
          auth: true,
          isConcurrent: true,
        })
          .then((result) => {
            const { body: { data } } = result
            resolve(data)
          })
          .catch(e => reject(e))

      })
    },

    /**
             * confirm email by activationCode
             *
             * @param email string email
             * @param code string code
             * @param {{ password: string }} additional string code
        */
    confirmByCode: (email, activationCode, additional = {}) => {
      return new Promise((resolve, reject) => {
        request(endpoints.confirmEmailByCode, {
          auth: true,
          method: 'PUT',
          isConcurrent: true,
          data: { email, activationCode, ...additional },
        })
          .then(result => {
            GtmService.pushEvent({ event: GtmEventTypes.RegistrationApproved })
            return resolve(result)
          })
          .catch(e => reject(e))
      })
    },

    /**
     * @param {string} email
     * @param {{ skipIfCodeValid?: boolean }} [options] `skipIfCodeValid`: the API sends nothing while the
     *   code of the last mail is still valid (DO-13064: automatic send when the confirm-email modal opens)
     */
    resendConfirmation: (email, { skipIfCodeValid = false } = {}) => {
      return new Promise((resolve, reject) => {
        request(endpoints.resendRegistrationEmail, {
          auth: true,
          method: 'PUT',
          isConcurrent: true,
          data: skipIfCodeValid ? { email, skipIfCodeValid: true } : { email },
        })
          .then((result) => resolve(result))
          .catch(e => reject(e))
      })
    },
  },
  acceptAvv: () => {
    return new Promise((resolve, reject) => {
      request(endpoints.acceptAvv, {
        auth: true,
        method: 'POST',
        isConcurrent: true,
      })
        .then(result => resolve(result.body))
        .catch(e => reject(e))
    })
  },
  resendAvv: () => {
    return new Promise((resolve, reject) => {
      request(endpoints.sendCurrentAvv, {
        auth: true,
        method: 'POST',
        isConcurrent: true,
      })
        .then(result => resolve(result))
        .catch(e => reject(e))
    })
  },
}
